/* global axios */

import ApiClient from '../ApiClient';

class WorkingHours extends ApiClient {
  constructor() {
    super('working_hours', { accountScoped: true });
  }

  update(id, data, query) {
    return axios.patch(`${this.url}/${id}`, data, { params: query });
  }
}

export default new WorkingHours();
